module.exports = __webpack_public_path__ + "img/moonbeam_logo.ccde170c.png";